import { render, staticRenderFns } from "./HomeJoin.vue?vue&type=template&id=ff6f95d0&"
import script from "./HomeJoin.vue?vue&type=script&lang=js&"
export * from "./HomeJoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports